import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-8" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "my-8" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "my-8" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "my-8" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "my-8" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "my-8" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "my-8" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "my-8" }
const _hoisted_21 = { class: "my-8" }
const _hoisted_22 = { class: "my-8" }
const _hoisted_23 = { class: "my-8" }
const _hoisted_24 = { class: "my-8" }
const _hoisted_25 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: _ctx.accountEditBreadcrumbItems
      }, null, 8, ["items"])
    ]),
    (_ctx.child)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.childcareType')), 1),
            _createVNode(_component_v_select, {
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              items: _ctx.childTypeOptions,
              "item-title": "label",
              "item-value": "value",
              modelValue: _ctx.childType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.childType) = $event)),
              color: "primary"
            }, null, 8, ["items", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('common.name')), 1),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      label: _ctx.$t('common.lastName'),
                      rules: [_ctx.required],
                      modelValue: _ctx.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                      color: "primary"
                    }, null, 8, ["label", "rules", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      label: _ctx.$t('common.firstName'),
                      rules: [_ctx.required],
                      modelValue: _ctx.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstName) = $event)),
                      color: "primary"
                    }, null, 8, ["label", "rules", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t('children.nurseryCodeNumber')), 1),
            _createVNode(_component_v_text_field, {
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              label: _ctx.$t('children.optionalCode1'),
              modelValue: _ctx.code1,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.code1) = $event)),
              class: "mb-2",
              color: "primary"
            }, null, 8, ["label", "modelValue"]),
            _createVNode(_component_v_text_field, {
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              label: _ctx.$t('children.optionalCode2'),
              modelValue: _ctx.code2,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.code2) = $event)),
              color: "primary"
            }, null, 8, ["label", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t('children.dateOfBirth')), 1),
            _createVNode(_component_date_picker, {
              modelValue: _ctx.dateOfBirth,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
              label: _ctx.$t('children.dateOfBirth')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('common.gender')), 1),
            _createVNode(_component_v_select, {
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              items: _ctx.genderOptions,
              "item-title": "label",
              "item-value": "value",
              modelValue: _ctx.gender,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gender) = $event)),
              color: "primary"
            }, null, 8, ["items", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t('children.admissionDate')), 1),
            _createVNode(_component_date_picker, {
              modelValue: _ctx.admissionDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.admissionDate) = $event)),
              label: _ctx.$t('children.admissionDate'),
              clearable: ""
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t('children.graduationDate')), 1),
            _createVNode(_component_date_picker, {
              modelValue: _ctx.graduationDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.graduationDate) = $event)),
              label: _ctx.$t('children.graduationDate'),
              clearable: ""
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$t('children.withdrawalDate')), 1),
            _createVNode(_component_date_picker, {
              modelValue: _ctx.moveOrLeave,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.moveOrLeave) = $event)),
              label: _ctx.$t('children.withdrawalDate'),
              clearable: ""
            }, null, 8, ["modelValue", "label"]),
            (_ctx.moveOrLeave)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_v_textarea, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    "full-width": "",
                    label: _ctx.$t('attendance.reason'),
                    modelValue: _ctx.moveOrLeaveReason,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.moveOrLeaveReason) = $event)),
                    color: "primary"
                  }, null, 8, ["label", "modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('common.class')), 1),
            _createVNode(_component_v_select, {
              items: _ctx.classOptions,
              "item-title": "className",
              "item-value": "classId",
              modelValue: _ctx.classIds,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.classIds) = $event)),
              multiple: "",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              color: "primary"
            }, null, 8, ["items", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.group')), 1),
            _createVNode(_component_v_select, {
              items: _ctx.groups || [],
              "item-title": "name",
              "item-value": "groupId",
              "return-object": "",
              modelValue: _ctx.groupIds,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.groupIds) = $event)),
              multiple: "",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              color: "primary"
            }, null, 8, ["items", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.extendedCarePattern')), 1),
            _createVNode(_component_v_select, {
              modelValue: _ctx.hoursPattern,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.hoursPattern) = $event)),
              items: _ctx.patternList,
              "item-title": "patternTitle",
              "return-object": "",
              variant: "outlined",
              density: "compact",
              "hide-details": "auto",
              color: "primary"
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.additionalStaffForSpecialNeeds')), 1),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.additionalStaffNum,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.additionalStaffNum) = $event)),
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              type: "number",
              min: 0,
              color: "primary"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.maxSubsidyAmount')), 1),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.maxSubsidyAmount,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.maxSubsidyAmount) = $event)),
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              type: "number",
              min: 0,
              color: "primary"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            (_ctx.isUpdating)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "my-8"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              "x-large": "",
              onClick: _ctx.update,
              disabled: _ctx.isUpdating
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_spacer)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}